import { render, staticRenderFns } from "./CustomerWizardFlow.vue?vue&type=template&id=e8966ca2&scoped=true"
import script from "./CustomerWizardFlow.vue?vue&type=script&lang=js"
export * from "./CustomerWizardFlow.vue?vue&type=script&lang=js"
import style0 from "./CustomerWizardFlow.vue?vue&type=style&index=0&id=e8966ca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8966ca2",
  null
  
)

export default component.exports